import { EuiHeaderSectionItemButton, EuiIcon } from "@elastic/eui";
import { useColorMode } from "./colorMode";
import { useAnketaI18n } from "../internationalization";

/**
 * Header control that flips between light and dark themes. Lives next to the
 * avatar/language controls in the app header.
 */
export const ThemeToggle = (): JSX.Element => {
  const { colorMode, toggleColorMode } = useColorMode();
  const { translate } = useAnketaI18n();

  const isDark = colorMode === "dark";
  const label = isDark
    ? translate("anketa.theme.switchToLight", {
        defaultMessage: "Switch to light theme",
      })
    : translate("anketa.theme.switchToDark", {
        defaultMessage: "Switch to dark theme",
      });

  return (
    <EuiHeaderSectionItemButton
      aria-label={label}
      title={label}
      onClick={toggleColorMode}
    >
      <EuiIcon type={isDark ? "sun" : "moon"} size="m" />
    </EuiHeaderSectionItemButton>
  );
};
